<template>
  <b-modal
    id="add-to-cart"
    ref="cartmodal"
    v-model="show"
    size="lg"
    hide-footer
    @hide="closeModal()"
  >
    <template #modal-header>
      <item-modal-add-to-cart-header :item="item" :show-prices="showPrices" @close-modal="closeModal()" />
    </template>

    <b-form v-if="loaded" @submit="addItemToCartSubmit()" @submit.prevent>
      <b-form-group
        v-if="item.variants && item.variants.length > 0"
        id="variantGroup"
        :label="$t('variant')"
        label-for="variant"
      >
        <b-form-select
          id="variant"
          v-model="variant"
          :options="variantValuesToSelectOptions(item.variants)"
          required
        ></b-form-select>
      </b-form-group>
      <template v-for="option in itemOptions">
        <b-form-checkbox
          v-if="option.values.length === 1"
          :id="`${option.optionID}`"
          :key="option.optionID"
          v-model="options[option.optionID]"
          :name="option.description"
          :value="option.values[0].optionValueID"
          :unchecked-value="null"
        >
          {{ option.description }}
        </b-form-checkbox>

        <b-form-group
          v-else
          :id="`${option.optionID}`"
          :key="option.optionID"
          :label="`${option.description}`"
          label-for="input-3"
        >
          <treeselect
            v-model="options[option.optionID]"
            :required="option.required"
            :multiple="false"
            :disable-branch-nodes="true"
            :searchable="true"
            :open-on-focus="true"
            :show-count="true"
            :options="optionValuesToSelectOptions(option.values)"
          />
        </b-form-group>
      </template>

      <b-form-group id="amount-group" :label="$t('amount')" label-for="amount">
        <b-form-input
          id="amount"
          v-model="qty"
          :placeholder="$t('amount')"
          required
        ></b-form-input>
      </b-form-group>

      <b-button v-if="processing" class="mt-3" block disabled
        ><i class="fas fa-spinner fa-spin"></i
      ></b-button>

      <div v-if="!item.allowAddToCart">
        {{ $t("addToCartCustomProductWarning") }}
        <a href="https://www.variphone.com/en/contact">{{ $t("contactUs") }}</a>
        {{ $t("addToCartCustomProductWarning2") }}
      </div>
      <div class="w-100 d-flex flex-row-reverse">
        <b-button class="mt-2 ml-2" @click="openInfoModal"
          ><i class="fas fa-info"></i
        ></b-button>

        <b-button
          v-if="!processing && item.allowAddToCart"
          block
          type="submit"
          class="mt-2"
          >{{ $t("addToCart") }}
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import {addItemToCart} from "@/services/cart";
import {getDimensionObjects} from "@/services/dimension";
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {mapGetters} from "vuex";
import ItemModalAddToCartHeader from "./ItemModalAddToCartHeader.vue";

import {
  BButton,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormSelect,
} from "bootstrap-vue";

export default {
  name: "ProductModalAddToCart",
  components: {
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckbox,
    Treeselect,
    ItemModalAddToCartHeader,
  },
  props: {
    showPrices: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      item: {},
      itemOptions: [],
      options: {},
      variant: "",
      persons: [],
      person: "",
      qty: 1,
      processing: false,
      loaded: false,
    };
  },

  computed: {
    customerid() {
      return this.$store.state.customerID;
    },
    ...mapGetters({
      showModal: "itemModal/showModal",
      type: "itemModal/type",
      itemid: "itemModal/itemId",
    }),
    show() {
      return this.showModal && this.type === "add-to-cart";
    },
  },
  watch: {
    itemid() {
      this.fetchItemData();
    },
    variant(value) {
      this.options = {};

      const variantOptions = this.item.variants.find(
        (variant) => variant.id === value,
      ).options;
      if (variantOptions)
        this.itemOptions = [...this.item.options, ...variantOptions];

      this.setDefaultValues();
    },
  },
  created() {
    const customerField = document.getElementsByName("customerid");

    if (customerField.length > 0) {
      this.$store.commit("setCustomerID", {
        customerID: customerField[0].value,
      });
    }

    this.itemOptions = this.item.options;
    this.options = this.item.options;
    this.fetchItemData();
  },

  methods: {
    openInfoModal() {
      this.$store.commit("itemModal/setType", "info");
    },
    closeModal() {
      this.$store.commit("itemModal/hideModal");
    },
    async fetchItemData() {
      window.location.hash = `add-to-cart-${this.itemid}`;

      if (Object.keys(this.item).length === 0) {
        // Only get item data if we do not already have it
        await this.getItemData();
        this.setDefaultValues();

        if (this.item.variants.length < 1) {
          this.itemOptions = this.item.options;
          this.options = this.item.options;
        }
        this.loaded = true;
      }
      const enabledVariants = this.item.variants.filter(
        (variant) => !variant.disabled,
      );
      if (enabledVariants.length) {
        this.variant = enabledVariants[0].id;
      }

      if (this.customerid) await this.getPersons();
    },
    async setDefaultValues() {
      for (const option of this.item.options) {
        for (const optionValue of option.values) {
          if (optionValue.default === true) {
            this.options[option.optionID] = optionValue.optionValueID;
            continue;
          }

          if (optionValue.childs !== null && optionValue.childs.length > 0) {
            for (const childOptionValue of option.childs) {
              if (childOptionValue.default === true) {
                this.options[option.optionID] = childOptionValue.optionValueID;
              }
            }
          }
        }
      }
    },
    async getItemData() {
      const requestData = await api.get("/api/v1/items", {
        params: {
          ItemID: this.itemid,
        },
      });

      this.item = requestData.data;
    },
    async getPersons() {
      this.persons = await getDimensionObjects({
        dimensionID: 3,
        customerID: this.customerid,
      });
      this.$store.commit("setPersons", this.persons);
    },
    optionValuesToSelectOptions(optionValues) {
      const selectOptions = [];
      for (const optionValue of optionValues) {
        let children = [];

        // If we have childs add them to the children property
        if (optionValue.childs !== null && optionValue.childs.length > 0) {
          for (const childOptionValue of optionValue.childs) {
            children.push({
              label: childOptionValue.description,
              id: childOptionValue.optionValueID,
              isDisabled: childOptionValue.disabled,
            });
          }
        }

        if (children.length === 0) {
          selectOptions.push({
            label: optionValue.description,
            id: optionValue.optionValueID,
            isDisabled: optionValue.disabled,
          });
        } else {
          selectOptions.push({
            label: optionValue.description,
            id: optionValue.optionValueID,
            isDisabled: optionValue.disabled,
            children,
          });
        }
      }
      return selectOptions;
    },
    variantValuesToSelectOptions(variants) {
      const selectVariants = [];
      for (const variant of variants) {
        selectVariants.push({
          text: variant.description,
          value: variant.id,
          disabled: variant.disabled,
        });
      }
      return selectVariants;
    },
    personValuesToSelectOptions(persons) {
      const selectPersons = [];
      for (const person of persons) {
        selectPersons.push({
          text: person.name,
          value: person.dimensionObjectID,
        });
      }
      return selectPersons;
    },
    async addItemToCartSubmit() {
      this.processing = true;
      let dimensionObjects = null;
      if (this.person) dimensionObjects = {3: this.person};

      // Remove null values from object
      Object.keys(this.options).forEach((key) =>
        this.options[key] === null ? delete this.options[key] : {},
      );

      await addItemToCart({
        itemID: this.itemid,
        qty: this.qty,
        options: this.options,
        variantID: this.variant,
        dimensionObjects,
      });

      this.$toasted.show(
        `${this.item.description} ${this.$t("successfullyAddedToCart")}`,
      );

      if (this.item.customOrderMessage) {
        this.$toasted.show(this.item.customOrderMessage);
      }

      this.$emit("cartupdate");

      this.$store.commit("setCartLastUpdated");

      this.processing = false;
    },
  },
};
</script>
<style lang="scss">
.vue-treeselect__option--disabled label.vue-treeselect__label {
  color: grey;
}
.vue-treeselect__control {
  border: 1px solid #cacaca;
  border-radius: 0;
  padding: 0;

  [type="text"]:focus {
    border: none;
    background-color: #fff;
    box-shadow: none;
    transition: none;
  }
}
</style>
